import { Button, Flex, Slot, Text } from '@/primitives'
import { Dialog } from '@/elements'

import { getDevice } from '@/reducers/selectors'

import Strings from '../../Strings'

const DeleteDeviceModal = ({ showModal, onAccept, onCancel }) => {
  const { removeDevice, cancel, remove, confirmRemoveDevice } = Strings()
  const device = getDevice()

  function onClickAccept(e) {
    e.preventDefault()
    onAccept(device)
  }

  function onClickClose(e) {
    e.preventDefault()
    onCancel()
  }

  return (
    <Dialog open={showModal} onOpenChange={onCancel}>
      <Slot name='title'>
        <Text size={300} fontWeight={700}>
          {removeDevice}
        </Text>
      </Slot>
      <Slot name='content'>
        <Text as='p'>{confirmRemoveDevice}</Text>
      </Slot>
      <Slot name='actions'>
        <Flex axisGap={400} alignMainAxis={'space-between'}>
          <Button variant='page' size={'small'} onClick={onClickClose}>
            {cancel}
          </Button>
          <Button variant='error' size={'small'} onClick={onClickAccept}>
            {remove}
          </Button>
        </Flex>
      </Slot>
    </Dialog>
  )
}

export default DeleteDeviceModal
